export default {
  langName: "Italiano",
  common: {
    company: "Un'azienda di Eagle Inc",
    privacy: "Privacy",
    terms: "Termini d'uso",
    support: "Assistenza",
  },
  nav: {
    group: "Eagle Eyes Group",
    realEstate: "Real Estate",
    itManagement: "IT Management",
    digitalServices: "Digital Services",
    backToGroup: "Eagle Eyes Group",
    property: "Property",
    investment: "Investment",
  },
  form: {
    name: "Nome completo",
    email: "Indirizzo email",
    sending: "Invio in corso…",
    sent: "Grazie — i tuoi dati sono arrivati. Ti ricontatteremo a breve.",
    error: "Qualcosa è andato storto. Riprova o scrivici direttamente.",
  },
  gateway: {
    hero1: "EAGLE",
    hero2: "EYES",
    hero3: "GROUP",
    chapters: [
      { num: "01", name: "Real Estate", sub: "Property · Investment — Tirana", desc: "Case in affitto curate con attenzione e un approccio verificabile e disciplinato all'investimento immobiliare residenziale.", cta: "Entra in Real Estate" },
      { num: "02", name: "IT Management", sub: "Consulenza & servizi gestiti", desc: "Consulenza IT senior su cloud, identità, sicurezza e DevOps — definita con precisione, consegnata di persona, gestita nel lungo periodo.", cta: "Entra in IT Management" },
      { num: "03", name: "Digital Services", sub: "Prodotti che costruiamo e gestiamo", desc: "Un portfolio crescente di prodotti web e mobile attivi in social commerce, marketing e prenotazioni — progettati e gestiti internamente.", cta: "Entra in Digital Services" },
    ],
    footerBrand: "Eagle Eyes Group",
  },
  re: {
    forClients: "Per i clienti",
    propertyH: "Property",
    propertyP: "Case in affitto nel centro di Tirana, trovate e curate con attenzione. Per chi cerca un posto dove vivere, non una transazione.",
    propertyCta: "Entra in Eagle Eyes Property",
    forInvestors: "Per gli investitori",
    investmentH: "Investment",
    investmentP: "Un approccio verificabile e disciplinato al residenziale di Tirana. Per chi vuole vedere esattamente cosa sta sostenendo.",
    investmentCta: "Entra in Eagle Eyes Investment",
  },
  property: {
    kicker: "Eagle Eyes Property",
    h1: "Una casa a Tirana, seguita fin dall'inizio.",
    intro: "Troviamo, prepariamo e gestiamo appartamenti in affitto nel centro di Tirana — per inquilini che vogliono una casa gestita bene, non solo un annuncio.",
    cta: "Unisciti alla lista d'attesa",
    navWhat: "Cosa facciamo",
    navHow: "Come funziona",
    navJoin: "Unisciti alla lista",
    whatTitle: "Cosa fa Eagle Eyes Property",
    whatMeta: "Onboarding in corso · Annunci in arrivo",
    what: [
      { label: "Selezione", title: "Appartamenti curati", text: "Ogni casa è scelta e ispezionata nei quartieri centrali di Tirana — niente ricerche infinite tra annunci che dal vivo non reggono." },
      { label: "Gestione", title: "Un unico punto di contatto", text: "Manutenzione, documenti e domande passano da un solo team, non da un proprietario irreperibile." },
      { label: "Trasparenza", title: "Termini chiari, da subito", text: "Prezzi, contratti e caparre spiegati chiaramente prima dell'impegno — nessuna sorpresa dopo il trasloco." },
    ],
    howTitle: "Come funziona",
    howMeta: "Tre passaggi",
    steps: [
      { title: "Raccontaci cosa cerchi", text: "Budget, quartiere, dimensioni, data di ingresso — le basi che restringono davvero la ricerca." },
      { title: "Ti abbiniamo alle case disponibili", text: "Ci sentirai quando avremo appartamenti adatti, non un flusso di opzioni sbagliate." },
      { title: "Trasloca, con supporto dopo", text: "Firmato, sistemato, seguito — Eagle Eyes resta il tuo punto di contatto per tutta la durata dell'affitto." },
    ],
    waitTitle: "Vedi gli appartamenti per primo",
    waitText: "Eagle Eyes Property sta avviando le sue prime case nel centro di Tirana. Lascia i tuoi dati e ti contatteremo appena gli annunci aprono.",
    neighbourhood: "Quartiere preferito (facoltativo)",
    waitButton: "Unisciti alla lista d'attesa",
    waitNote: "Niente spam — solo un messaggio quando gli appartamenti diventano disponibili.",
    footerBrand: "Eagle Eyes Property",
  },
  investment: {
    kicker: "Eagle Eyes Investment",
    h1: "Immobili residenziali a Tirana, costruiti per essere verificati.",
    intro: "Eagle Eyes acquista e affitta appartamenti nel centro di Tirana tramite una holding albanese strutturata — gestita in modo che ogni affermazione possa essere verificata, non solo presa in buona fede.",
    cta: "Richiedi il pacchetto informativo",
    navThesis: "Come è costruita",
    navTrack: "Track record",
    navContact: "Contatti",
    thesisTitle: "Come è costruita Eagle Eyes",
    thesisP1: "Acquistiamo appartamenti nei quartieri centrali di Tirana, li affittiamo a inquilini selezionati tramite Eagle Eyes Property e li deteniamo in una struttura societaria dedicata — separando proprietà, gestione e rendicontazione affinché ciascuna possa essere esaminata singolarmente.",
    thesisP2: "L'obiettivo è un portfolio che cresce con deliberazione: meno acquisizioni, ciascuna documentata abbastanza bene da permettere a un investitore di ricostruire il nostro ragionamento senza doversi fidare sulla parola.",
    specs: [
      { k: "Proprietà", v: "Holding albanese / struttura SPV" },
      { k: "Operazioni", v: "Gestite tramite Eagle Eyes Property" },
      { k: "Focus", v: "Appartamenti residenziali nel centro di Tirana" },
      { k: "Rendicontazione", v: "Documentazione disponibile su richiesta" },
    ],
    trackTitle: "Track record",
    trackMeta: "Prime acquisizioni in corso",
    trackBoxTitle: "Risultati oggetto per oggetto — in arrivo",
    trackBoxText: "Man mano che gli appartamenti vengono acquistati, affittati e (ove applicabile) ceduti, ciascuno sarà elencato qui con le cifre sottostanti — costo di acquisizione, lavori eseguiti, occupazione e rendimento.",
    trackBoxNote: "Vuoi lo stato attuale prima della pubblicazione? Chiedi qui sotto.",
    verifyTitle: "Cosa possono esaminare gli investitori verificati",
    verify: [
      { label: "Entità", title: "Struttura societaria", text: "Documenti di registrazione della holding e della SPV, e come la proprietà di ogni appartamento si colloca al di sotto." },
      { label: "Asset", title: "Dettaglio per immobile", text: "Posizione, condizione, termini di acquisizione e stato locativo di ogni appartamento detenuto o in offerta." },
      { label: "Finanze", title: "Le cifre sottostanti", text: "Costi, condizioni di finanziamento e redditi locativi del portfolio — condivisi direttamente, non riassunti." },
      { label: "Persone", title: "Chi c'è dietro", text: "Background su chi gestisce Eagle Eyes e su come i lati Property e Investment si relazionano tra loro." },
    ],
    contactTitle: "Chiedi di vedere i dettagli",
    contactText: "Dicci chi sei e cosa vorresti verificare. Ti risponderemo direttamente con la documentazione pertinente.",
    roleLabel: "Ti presenti come…",
    roles: ["Un potenziale investitore", "Un investitore esistente", "Altro / consulente"],
    verifyField: "Cosa vorresti verificare? (facoltativo)",
    contactButton: "Richiedi informazioni",
    contactNote: "La documentazione è condivisa direttamente con persone nominate, non pubblicata apertamente.",
    footerBrand: "Eagle Eyes Investment",
  },
  it: {
    kicker: "IT Management",
    h1a: "Eagle Eyes",
    h1b: "IT Management",
    hero: "Consulenza IT end-to-end su misura per le tue esigenze — da soluzioni mirate a scope singolo e strategie complete, fino alla gestione del portfolio a lungo termine e alla manutenzione continuativa",
    heroCta: "Inizia una conversazione",
    navProcess: "Come lavoriamo",
    navExpertise: "Competenze",
    navEngagements: "Incarichi",
    profileTitle: "Profilo",
    profile: "Eagle Eyes IT Management è una realtà di management e consulenza al servizio di clienti in tutto il mondo. I nostri consulenti seguono direttamente ogni cliente dal primo incontro alla consegna finale — endpoint, identità, gestione dispositivi, sicurezza e cloud hosting su Azure e Microsoft 365 — e restano responsabili del portfolio per l'intera durata del contratto.",
    processTitle: "Come lavoriamo",
    process: [
      { num: "01", title: "Scope first", text: "Ogni incarico parte dalla tua richiesta, da incontri di approfondimento e da uno scope scritto: deliverable, criteri di accettazione, niente ambiguità." },
      { num: "02", title: "Discovery", text: "Un'analisi dettagliata su ore di consulenza concordate, fatturate in anticipo, che si conclude con una proposta interamente costata." },
      { num: "03", title: "Contratti", text: "Servizi singoli fatturati in anticipo. Lavoro continuativo calibrato sulla tua organizzazione. Gestione del portfolio e manutenzione su contratti annuali con fatturazione mensile. Combinazioni negoziabili." },
    ],
    expertiseTitle: "Competenze",
    expertise: [
      { title: "Modern workplace", items: "Windows 11 · Intune · Autopilot" },
      { title: "Microsoft 365", items: "Exchange · SharePoint · Teams · Migrazioni" },
      { title: "Sicurezza", items: "Defender · Hardening · Secrets · Patching" },
      { title: "Service management", items: "Jira · JSM · Confluence · Process design" },
      { title: "Identity & access", items: "Entra ID · Conditional access · MFA · SSO" },
      { title: "Azure & hosting", items: "IaaS / PaaS · Networking · Domini · SSL" },
      { title: "DevOps & CI/CD", items: "Azure DevOps · Bitbucket · Pipeline" },
      { title: "IT management", items: "Service design · Fornitori · Budget" },
    ],
    engagementsTitle: "Incarichi selezionati a lungo termine",
    engagements: [
      { client: "Multinazionale di software linguistico", role: "IT Business Consultancy & Global DevOps Management", text: "Costituzione della più recente filiale nazionale e progettazione dell'architettura IT globale della corporation. L'incarico ha comportato la crescita delle operazioni locali da 5 a 60 professionisti in 18 mesi, costruendo e guidando al contempo i team cross-funzionali di DevOps e IT management che gestiscono l'infrastruttura degli uffici globali." },
      { client: "Autorità globale nell'ingegneria del software", role: "IT Cloud & DevOps Consultancy", text: "Strutturazione e ottimizzazione dell'infrastruttura IT aziendale per un leader mondialmente riconosciuto nello sviluppo software. L'incarico ha comportato la costruzione da zero di un ecosistema DevOps ad alte prestazioni e la progettazione di un'infrastruttura datacenter ibrida a supporto di oltre 500 utenti interni." },
      { client: "Fornitore nazionale di servizi enterprise", role: "IT Cloud Consultancy & VoIP Architecture", text: "Consulenza tecnica embedded e in-house per clienti B2B di primo livello e service provider. Il focus principale: progettazione e implementazione di architetture VoIP altamente scalabili e soluzioni cloud di livello enterprise." },
    ],
    contactTitle: "Inizia una conversazione",
    contactText: "Raccontaci il tuo ambiente e cosa vuoi ottenere. Rispondiamo personalmente — di solito entro un giorno lavorativo.",
    companyField: "Azienda (facoltativo)",
    messageField: "Come possiamo aiutarti?",
    contactButton: "Invia richiesta",
    contactBlockTitle: "Contatti",
    servicesTitle: "Servizi & Competenze",
    productsTitle: "Prodotti & Brand",
    portfolioTitle: "Gestione del Portfolio",
    services: ["Modern workplace", "Microsoft 365", "Sicurezza", "Service management", "Identity & access", "Azure & hosting", "DevOps & CI/CD", "IT management"],
    products: ["Microsoft 365", "Azure", "Entra ID", "Intune", "PowerShell", "Azure DevOps", "Bitbucket", "Postman", "Jira", "Jira Service Management", "Confluence", "Twilio", "Agora"],
    portfolio: ["Service design", "Gestione fornitori", "Responsabilità budget", "Manutenzione & supporto", "Contratti annuali", "Fatturazione mensile"],
    footerBrand: "Eagle Eyes IT Management",
  },
  digital: {
    kicker: "Eagle Eyes Digital Services",
    h1: "Prodotti che costruiamo, gestiamo e facciamo crescere.",
    intro: "Digital Services è lo studio di prodotto di Eagle Eyes: progettiamo, lanciamo e gestiamo i nostri prodotti web e mobile in social commerce, marketing e prenotazioni.",
    navPortfolio: "Il portfolio",
    navDeals: "Offerte & Marketing",
    navContact: "Contatti",
    appsTitle: "Il portfolio",
    live: "Live",
    soon: "In arrivo",
    capsTitle: "Cosa costruiamo",
    caps: [
      { title: "Social commerce", text: "Trasformare il pubblico in clienti con pick e offerte acquistabili." },
      { title: "Campagne & offerte", text: "Promozioni a tempo pensate per la condivisione e la conversione rapida." },
      { title: "Prenotazioni & agenda", text: "Appuntamenti, disponibilità e promemoria senza attriti." },
      { title: "Analisi & insight", text: "Ogni prodotto misurato dal primo click al cliente abituale." },
    ],
    studioTitle: "Uno studio di prodotto interno",
    studioText: "Digital Services progetta, costruisce e gestisce i prodotti di Eagle Eyes end to end — dal primo schizzo all'infrastruttura, al supporto e alla crescita. Niente lavori per clienti, niente agenzie: i nostri prodotti, il nostro standard.",
    statProducts: "Prodotti",
    statLive: "Live",
    statLaunching: "In lancio",
    apps: [
      { name: "Socialdeal", tag: "Offerte & marketing", status: "live", desc: "Socialdeal offre alle attività locali un modo rapido di pubblicare offerte e campagne a tempo, pensato per la condivisione social e la conversione diretta.", url: "https://www.socialdeal.al/", cta: "Visita Socialdeal", features: ["Pubblicazione di offerte a tempo", "Pensato per la condivisione social", "Flussi di conversione diretta"] },
      { name: "BookItNow", tag: "Piattaforma di prenotazione", status: "soon", desc: "BookItNow è il nostro prodotto più recente: prenotazioni online semplici e veloci per le attività di servizio — appuntamenti, disponibilità e promemoria in un unico posto.", url: "", cta: "In arrivo", features: ["Prenotazione appuntamenti online", "Disponibilità in tempo reale", "Promemoria automatici"] },
      { name: "InContact", tag: "Telefonia SIP & PBX", status: "soon", desc: "InContact è il nostro sistema SIP & PBX: telefonia cloud con numeri aziendali, instradamento delle chiamate e code — gestito online, senza hardware in sede.", url: "", cta: "In arrivo", features: ["Trunk SIP & PBX hosted", "Instradamento & gruppi di chiamata", "Numeri e segreteria online"] },
    ],
    contactTitle: "Lavora con noi",
    contactText: "Interessato a un prodotto, una partnership o un progetto pilota? Lascia un messaggio e ti ricontatteremo.",
    messageField: "Il tuo messaggio",
    contactButton: "Invia messaggio",
    footerBrand: "Eagle Eyes Digital Services",
  },
  inc: {
    hero1: "EAGLE",
    hero2: "INC",
    intro: "Una holding, due gruppi — dove servizio e sviluppo si incontrano.",
    eyesBtn: "Eagle Eyes Group",
    eyesSub: "Real Estate · IT Management · Digital Services",
    eyesCta: "Entra in Eagle Eyes Group",
    commerceBtn: "Eagle Commerce Group",
    commerceSub: "Socialdeal · BookItNow · InContact",
    commerceCta: "Entra in Eagle Commerce Group",
    footerBrand: "Eagle Inc",
    footerLegal: "Eagle Inc Sh.P.K.",
    tagline: "Società holding",
  },
  commerce: {
    hero1: "EAGLE",
    hero2: "COMMERCE",
    hero3: "GROUP",
    intro: "Eagle Commerce Group progetta, lancia e gestisce i propri prodotti e-commerce — dalle offerte locali alle prenotazioni e al contatto con i clienti.",
    live: "Live",
    soon: "Prossimamente",
    visit: "Visita",
    explore: "Scopri",
    products: [
      { name: "Socialdeal", tag: "Offerte & marketing", status: "live", desc: "Offerte locali e campagne di marketing — pubblicate in fretta, condivise sui social, convertite direttamente.", url: "https://www.socialdeal.al/", brand: "Eagle Commerce Socialdeal", h1: "Offerte locali, fatte per essere condivise.", story: "Socialdeal offre alle attività locali un modo semplice e social per pubblicare offerte a tempo e campagne — pensato per la condivisione, calibrato sulla conversione diretta.", points: ["Pubblicazione di offerte a tempo", "Pensato per la condivisione social", "Flussi di conversione diretta"] },
      { name: "BookItNow", tag: "Piattaforma di prenotazione", status: "soon", desc: "Prenotazioni online semplici e veloci per le attività di servizio — appuntamenti, disponibilità e promemoria in un unico posto.", url: "", brand: "Eagle Commerce BookItNow", h1: "Prenotare, senza attriti.", story: "BookItNow permette alle attività di servizi di accettare appuntamenti online in pochi minuti — disponibilità in tempo reale, promemoria automatici e un flusso di prenotazione che i clienti completano davvero.", points: ["Prenotazione appuntamenti online", "Disponibilità in tempo reale", "Promemoria automatici"] },
      { name: "InContact", tag: "Telefonia SIP & PBX", status: "soon", desc: "Telefonia cloud per le aziende: trunk SIP, PBX hosted e ogni numero in un unico posto.", url: "", brand: "Eagle Commerce InContact", h1: "Telefonia aziendale, senza hardware.", story: "InContact è una piattaforma SIP & PBX completa nel cloud: numeri aziendali, instradamento delle chiamate, code e segreteria — gestita online, senza hardware in sede.", points: ["Trunk SIP & PBX hosted", "Instradamento & code", "Numeri gestiti online"] },
    ],
    footerBrand: "Eagle Commerce Group",
  },
};
